import { Accordion, Col, Nav, Row, Tab } from "react-bootstrap";
import { TimeIcon, ViewIcon } from "../../../../../assets/icons/svgicons";
import CardLost from "./CardLost/CardLost";
import FailedTransaction from "./FailedTransaction/FailedTransaction";
import styles from "./ReportIssues.module.scss";
import WrongDeducation from "./WrongDeducation/WrongDeducation";
import CardNotWorking from "./CardNotWorking/CardNotWorking";
import FraudAlert from "./FraudAlert/FraudAlert";
import UPIIssue from "./UPIIssue/UPIIssue";
import TechnicalError from "./TechnicalError/TechnicalError";
import OtherIssues from "./OtherIssues/OtherIssues";
import { ROUTES } from "../../../../../routes";
import { useState } from "react";
import { Link } from "react-router-dom";

const ReportIssues = () => {
  const [activeTab, setActiveTab] = useState("FailedTransaction");
  const items = [
    { label: "Failed Transaction", key: "FailedTransaction" },
    { label: "Card Lost", key: "CardLost" },
    { label: "Wrong Deducation", key: "WrongDeducation" },
    { label: "Card Not Working", key: "CardNotWorking" },
    { label: "Fraud Alert", key: "FraudAlert" },
    // { label: "UPI Issue", key: "UPIissue" },
    { label: "Technical Error", key: "TechnicalError" },
    { label: "Other", key: "OtherIssues" },
  ];

  return (
    <Tab.Container
      activeKey={activeTab}
      onSelect={(key) => setActiveTab(key)}
      mountOnEnter
      unmountOnExit
    >
      <div className={styles.report_issues}>
        <div className={styles.report_issues_head}>
          <Row>
            <Col xxl={9} >
              <div className={styles.head_left}>
                <h5>What is the issue related to?</h5>

                <Row>
                  {items.map((item, index) => (
                    <Col xxl={3} lg={6} md={6} sm={12} key={index}>
                      <div className={styles.head_left_in}>
                        <Nav.Link eventKey={item.key}>
                          <TimeIcon />
                          {item.label}
                        </Nav.Link>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            </Col>

            <Col xxl={3}>
              <div className={styles.head_right}>
                <h5>Need Help?</h5>
                <Accordion>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      How long does a resolution take?
                    </Accordion.Header>
                    <Accordion.Body>
                      Typically, resolutions are processed within 24 to 48 business hours. You will receive an update via email or notification once it's resolved.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                      Where can I find my Transaction ID?
                    </Accordion.Header>
                    <Accordion.Body>
                      You can find your Transaction ID in the "Transaction History" section of your dashboard or in the confirmation email/SMS received after the transaction.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                      What if my issue isn't listed?
                    </Accordion.Header>
                    <Accordion.Body>
                      If your issue isn't listed, please select "Other Issues" and provide a detailed description. Our support team will review it and get back to you.
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
                <Link className={styles.head_right_link} to={ROUTES.HELP}>
                  Visit Help Center <ViewIcon />
                </Link>
              </div>
            </Col>
          </Row>
        </div>

        <Tab.Content>
          <Tab.Pane eventKey="FailedTransaction">
            <FailedTransaction />
          </Tab.Pane>
          <Tab.Pane eventKey="CardLost">
            <CardLost />
          </Tab.Pane>
          <Tab.Pane eventKey="WrongDeducation">
            <WrongDeducation />
          </Tab.Pane>
          <Tab.Pane eventKey="CardNotWorking">
            <CardNotWorking />
          </Tab.Pane>
          <Tab.Pane eventKey="FraudAlert">
            <FraudAlert />
          </Tab.Pane>
          {/* <Tab.Pane eventKey="UPIissue">
            <UPIIssue />
          </Tab.Pane> */}
          <Tab.Pane eventKey="TechnicalError">
            <TechnicalError />
          </Tab.Pane>
          <Tab.Pane eventKey="OtherIssues">
            <OtherIssues />
          </Tab.Pane>
        </Tab.Content>
      </div>
    </Tab.Container>
  );
};

export default ReportIssues;
